import React, { createContext, useState, useEffect, useContext } from 'react';
import { auth } from '../firebase/firebaseInit';
// eslint-disable-next-line import/named
import { signOut, onAuthStateChanged } from 'firebase/auth';


const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = () => {
    console.log('Logout requested');
    return signOut(auth);
  };

  useEffect(() => {
    console.log('Setting up Firebase auth state listener...');
    
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log('Auth state changed:', {
        isAuthenticated: !!user,
        userId: user?.uid,
        email: user?.email,
        emailVerified: user?.emailVerified,
        metadata: user?.metadata
      });
      
      setCurrentUser(user);
      setLoading(false);
    });

    return () => {
      console.log('Cleaning up Firebase auth state listener');
      unsubscribe();
    };
  }, []);

  const value = {
    currentUser,
    loading,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export default AuthContext;